// style
import './style/home.css'
// react
import React, { useEffect, useState } from "react";
// layout
import Header from './../../../layouts/template/client/header/header.tsx';
import Footer from '../../../layouts/template/client/footer/footer.tsx';
// seo
import Seo from '../../../features/seo/seo.tsx';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import "swiper/css/pagination"
import "swiper/css/navigation"
import 'swiper/css/effect-cards';
import 'swiper/css/effect-coverflow';
// import required modules
import { EffectCards, Navigation, Autoplay, Pagination, EffectCoverflow } from 'swiper/modules';
// option
import { commentOption, swiperOption } from "../../../features/swiperOption/swiperOption.tsx";
// icons
import { IconMapPin, IconStar } from '@tabler/icons-react'
// router
import { Link } from 'react-router-dom';
// component
import Ability from '../../../components/childrens/ability/ability.tsx';
import Barline from '../../../components/childrens/barline/barline.tsx';
import Plans from "../../../components/childrens/plans/plans.tsx";
import Modal from '../../../components/basement/modal/modal.tsx';
// query
import { GetPlans } from "../../../services/client/plans/getPlans.tsx";
// toast
import { ToastContainer } from 'react-toastify';
import useGetData from '../../../hook/getData.tsx';


const Home = () => {
    const { data: plans } = useGetData(['plans'], GetPlans)
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        if (plans?.length) {
            setIsReady(true);
        }
    }, [plans]);
    return (
        <>
            <Seo
                name="viraCompany"
                title="مادوند | کیفیتی بالا و تحولی سریع"
                keywords="مادوند،ملک،تعرفه،خدمات،رهن،اجاره،سرمایه گذاری"
                description="با تجربه‌ای نو، کیفیتی بالا و تحویل سریع، ملک شما را به فضایی مدرن و ارزشمند تبدیل می‌کنیم و  سرمایه‌گذاری شما را بهبود می‌بخشیم"
            />
            <section id="banner">
                <div className='container-fluid h-100'>
                    <div className='row bg-gradient align-content-md-between align-content-start h-100'>
                        <div className='col-12'>
                            <div className='container-fluid'>
                                {/* header */}
                                <Header />
                            </div>
                        </div>
                        <div className='col-12 text-white py-md-4 py-3'>
                            <div className='container-fluid'>
                                <div className='row align-items-center'>
                                    <div className='col-lg-9 col-md-7' data-aos="fade-up" data-aos-duration={'1500'}>
                                        <h1 className='text-white d-md-inline-block d-none fw-bold'>
                                            املاک مادوند
                                        </h1>
                                        <h2 className='text-white font-large line-30'>
                                            با املاک مادوند، خرید ملکی مطمئن و با ارزش را تجربه کنید.
                                            <br className='d-lg-inline-block d-none' />
                                            انتخابی هوشمندانه با مشاوره تخصصی و خدمات حرفه‌ای برای سرمایه‌گذاری بهتر
                                        </h2>
                                        <button data-bs-toggle="modal" data-bs-target="#photograph" className='btn btn-primary mt-3'>
                                            ثبت نام عکاسان
                                        </button>
                                    </div>
                                    <div className='col-lg-3 col-md-5 overflow-x-hidden d-md-inline-block d-none' data-aos="fade-down" data-aos-duration={'1500'}>
                                        <div className='slider pe-4'>
                                            <Swiper
                                                effect={'cards'}
                                                grabCursor={true}
                                                spaceBetween={30}
                                                loop={true}
                                                modules={[EffectCards]}
                                                className="mySwiper"
                                            >
                                                {Array.from({ length: 5 }, (_, index) => (
                                                    <SwiperSlide key={index + ""}>
                                                        <div className='card gallery-card card-body rounded rounded-4'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='card-items pe-3'>
                                                                    <span className='badge bg-secondary'>گالری</span>
                                                                    <p className='mb-0 card-title h5 fw-bold mt-3'>
                                                                        ملک تبریز
                                                                    </p>
                                                                    <p className='mb-0 text-muted font-medium-lg mt-2 fw-bold'>
                                                                        واقع در شهزاد
                                                                        ،
                                                                        کوی دوازده پلاک 122
                                                                    </p>
                                                                </div>
                                                                <img alt='gallery' src={require('./../../../assets/media/backgrounds/background.webp')} />
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        </div>
                                        <div className='d-flex align-items-center justify-content-between mt-4'>
                                            <h4 className='h6 fw-bold mb-0'>پیدا کردن خانه رویایی شما</h4>
                                            <div className='stars'>
                                                {Array.from({ length: 5 }, (_, index) => (
                                                    <IconStar key={index + "star"} size={16} className='text-warning' />
                                                ))}
                                            </div>
                                        </div>
                                        <p className='font-medium text-white mt-3 mb-1'>
                                            ملک خود را میخواهید بفروشید ؟ به ما بسپارید تا در سریعترین زمان به فروش برسد
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='container-fluid px-md-4'>
                <section id='title' className='row align-items-center my-5 overflow-hidden'>
                    <div className='col-md-6 col-12' data-aos="fade-left" data-aos-duration={'1500'}>
                        <img src={require('../../../assets/media/banner/tabriz.png')} alt='Tabriz'
                            className='img-fluid rounded rounded-start-5' />
                    </div>
                    <div className='col-md-6 mt-md-0 mt-4' data-aos="fade-right" data-aos-duration={'1500'}>
                        <h2 className='h3 fw-bold card-title'>
                            مادوند ملک
                        </h2>
                        <p className='card-text font-large line-30 mt-3'>
                            خانه رویایی‌تان تنها چند کلیک با شما فاصله دارد! ما با ارائه
                            بهترین فایل‌های خرید، فروش و اجاره، در کنار شما هستیم تا سریع‌ترین و مطمئن‌ترین مسیر را برای یافتن ملک ایده‌آل طی کنید.
                            از این رو
                            بهترین املاک در بهترین مناطق! با ما، خانه‌ای مطابق با نیاز و بودجه خود پیدا کنید و تجربه‌ای متفاوت در خرید و اجاره ملک داشته باشید
                        </p>
                        <div className='d-flex justify-content-end'>
                            <button data-bs-toggle="modal" data-bs-target="#agent" className='btn btn-outline-primary'>
                                ثبت نام مشاور املاک
                            </button>
                        </div>
                    </div>
                </section>
                <section id='ability'>
                    <p className='blockquote-footer font-large fw-bold card-title'>
                        خدمات ما
                    </p>
                    <Ability />
                </section>
                <section id='description' className='row align-items-center my-4'>
                    <div className='col-md-6 order-md-0 order-1'>
                        <h3 className='h4 fw-bold card-title'>
                            انتخاب پلن
                        </h3>
                        <p className='card-text font-large line-30 mt-3'>
                            وب‌سایت جامع املاک شما؛ جایی که می‌توانید بین صدها گزینه متنوع، خانه‌ای متناسب با سبک زندگی و نیاز خود بیابید
                            از این رو اگر از جستجوی بی‌پایان در بازار املاک خسته شده‌اید؟ ما در کنار شما هستیم تا بهترین فرصت‌های ملکی را با شفافیت و کیفیت به شما ارائه دهیم
                        </p>
                    </div>
                    <div className='col-md-6 col-12 animated-img order-md-1 order-0'>
                        {isReady && (
                            <Swiper
                                effect={'coverflow'}
                                grabCursor={true}
                                centeredSlides={true}
                                slidesPerView={'auto'}
                                loop={true}
                                coverflowEffect={{
                                    rotate: 50,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 1,
                                    slideShadows: false,
                                }}
                                modules={[EffectCoverflow, Pagination]}
                                className="mySwiper"
                            >
                                {plans.map((item: any) => (
                                    <SwiperSlide key={item.title}>
                                        <Plans item={item} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}
                    </div>
                </section>
                <section id='second-banner' className='rounded rounded-4'>
                    <div className='container-fluid p-4'>
                        <div className='row'>
                            <div className='col-md-5'>
                                <div className='card card-body rounded rounded-4 border-0 shadow-site p-md-4' data-aos="fade-up" data-aos-duration={'1500'}>
                                    <h3 className='h5 fw-bold card-title mb-2'>
                                        پیدا کردن خانه رویایی شما
                                    </h3>
                                    <h6 className='card-subtitle mt-2'>
                                        بیش از 1000 خانه، آپارتمان، باغ و ویلا برای فروش و اجاره در املاک مادوند
                                    </h6>
                                    <hr />
                                    <p className='card-text line-30 mb-1'>
                                        با ما در کوتاه‌ترین زمان ممکن، خانه دلخواهتان را پیدا کنید؛ مجموعه‌ای بی‌نظیر از آپارتمان‌ها، ویلاها و زمین‌ها در بهترین مناطق شهری و روستایی در انتظار شماست که چه بسا با ما، آینده‌ای روشن در دنیای املاک بسازید؛ انتخاب از بین صدها گزینه متنوع در مناطق مختلف، همراه با خدمات مشاوره‌ای که برای موفقیت شما طراحی شده است.
                                    </p>
                                    <div className='btns d-flex justify-content-end'>
                                        <button data-bs-toggle="modal" data-bs-target="#photograph" className='btn btn-outline-primary mt-3'>
                                            ثبت نام عکاسان
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id='galleries' className='my-5 mb-3'>
                    <p className='blockquote-footer font-large fw-bold card-title'>
                        گالری
                    </p>
                    <Swiper
                        className={'page-slider w-100'}
                        modules={[Autoplay, Navigation, Pagination]}
                        navigation={{
                            prevEl: '.next',
                            nextEl: '.prev',
                        }}
                        loop={true}
                        spaceBetween={20}
                        pagination={true}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={
                            swiperOption
                        }
                    >
                        {Array.from({ length: 5 }, (_, index) => (
                            <SwiperSlide key={index + "gallery"}>
                                <div className='card card-body rounded rounded-4 border-0 shadow-site'>
                                    <img className='img-fluid rounded rounded-3' alt='amlak' src={require('./../../../assets/media/backgrounds/background.webp')} />
                                    <div className='d-flex justify-content-between align-items-center mt-3'>
                                        <p className='card-subtitle font-medium text-muted mb-0'>
                                            <IconMapPin size={14} className='align-middle me-1' />
                                            شهرزاد ، جنب پاساژ اطلس
                                        </p>
                                        <span className='badge bg-secondary'>ویلایی</span>
                                    </div>
                                    <p className='h5 fw-bold card-title mb-2 mt-1'>
                                        خانه ویلایی تبریز
                                    </p>
                                </div>
                            </SwiperSlide>
                        ))}
                        <div className="prev">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34"
                                viewBox="0 0 34 34" fill="none">
                                <path
                                    d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z"
                                    fill="#26466d" fillOpacity="0.61" />
                                <path d="M19.142 23.001L13.158 17L19.142 10.999" stroke="white"
                                    strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="next">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34"
                                viewBox="0 0 34 34" fill="none">
                                <path
                                    d="M16.8334 33.8333C7.53661 33.8333 6.10352e-05 26.2968 6.10352e-05 17C6.10352e-05 7.70317 7.53661 0.166626 16.8334 0.166626C26.1302 0.166626 33.6667 7.70317 33.6667 17C33.6667 26.2968 26.1302 33.8333 16.8334 33.8333Z"
                                    fill="#26466d" fillOpacity="0.61" />
                                <path d="M14.7124 22.9422L20.6377 17L14.7124 11.0579" stroke="white"
                                    strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                        </div>
                    </Swiper>
                </section>
                <section id='card-slider' className='d-md-none d-block mt-5'>
                    <div className='row'>
                        <div className='col-12 overflow-hidden px-4'>
                            <div className='slider'>
                                <Swiper
                                    effect={'cards'}
                                    grabCursor={true}
                                    spaceBetween={30}
                                    loop={true}
                                    cardsEffect={{
                                        slideShadows: false,
                                    }}
                                    modules={[EffectCards]}
                                    className="mySwiper"
                                >
                                    {Array.from({ length: 5 }, (_, index) => (
                                        <SwiperSlide key={index + "slider"}>
                                            <div className='card gallery-card card-body rounded rounded-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='card-items pe-3'>
                                                        <span className='badge bg-secondary'>گالری</span>
                                                        <p className='mb-0 card-title h5 fw-bold mt-3'>
                                                            ملک تبریز
                                                        </p>
                                                        <p className='mb-0 text-muted font-medium-lg mt-2 fw-bold'>
                                                            واقع در شهزاد
                                                            ،
                                                            کوی دوازده پلاک 122
                                                        </p>
                                                    </div>
                                                    <img alt='gallery' src={require('./../../../assets/media/backgrounds/background.webp')} />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div className='d-flex align-items-center justify-content-between mt-3'>
                                <h4 className='h6 fw-bold mb-0'>پیدا کردن خانه رویایی شما</h4>
                                <div className='stars'>
                                    {Array.from({ length: 5 }, (_, index) => (
                                        <IconStar key={index + "secondStart"} size={16} className='text-warning' />
                                    ))}
                                </div>
                            </div>
                            <p className='font-medium mt-3 mb-1'>
                                ملک خود را میخواهید بفروشید ؟ به ما بسپارید تا در سریعترین زمان به فروش برسد
                            </p>
                            <Link to={'#'} className='text-decoration-none font-medium text-end d-block'>
                                مشاهده همه
                            </Link>
                        </div>
                    </div>
                </section >
                <section id='barline' className='mt-md-0 mt-5 rounded rounded-3'>
                    <div className='row align-items-center'>
                        <div className='col-md-3 col-4'>
                            <img alt='home' className='img-fluid' src={require('./../../../assets/media/banner/aboutHome.png')} />
                            <h5 className='text-white responsive-text text-center mt-2 fw-bold'>
                                چرا مادوند ملک ؟
                            </h5>
                        </div>
                        <div className='col-md-9 col-8'>
                            <div className='card card-body border-0 shadow-site'>
                                <Barline />
                            </div>
                        </div>
                    </div>
                </section>
                <section id='comments' className='mt-5'>
                    <p className='blockquote-footer font-large fw-bold card-title'>
                        نظرات
                    </p>
                    <Swiper
                        className={'page-slider w-100'}
                        modules={[Autoplay, Navigation]}
                        navigation={{
                            prevEl: '.next',
                            nextEl: '.prev',
                        }}
                        loop={true}
                        spaceBetween={30}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={
                            commentOption
                        }
                    >
                        {Array.from({ length: 5 }, (_, index) => (
                            <SwiperSlide key={index + 'comment'}>
                                <div className='item py-4' data-aos="fade-down" data-aos-duration={'1500'}>
                                    <div className='card card-body border-0 shadow-site mb-1'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <img alt='activity'
                                                src={require('./../../../assets/media/icon/reza.webp')}
                                                className='comment-profile' />
                                            <div className='stars'>
                                                <span className='badge bg-primary'>
                                                    3
                                                    <IconStar size={15} className='ms-1' />
                                                </span>
                                            </div>
                                        </div>
                                        <h6 className='card-title fw-bold mb-0 mt-3'>رضا مهوشی</h6>
                                        <hr />
                                        <p className='card-text'>
                                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                        <div className="prev">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34"
                                viewBox="0 0 34 34" fill="none">
                                <path
                                    d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z"
                                    fill="#26466d" fillOpacity="0.61" />
                                <path d="M19.142 23.001L13.158 17L19.142 10.999" stroke="white"
                                    strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="next">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34"
                                viewBox="0 0 34 34" fill="none">
                                <path
                                    d="M16.8334 33.8333C7.53661 33.8333 6.10352e-05 26.2968 6.10352e-05 17C6.10352e-05 7.70317 7.53661 0.166626 16.8334 0.166626C26.1302 0.166626 33.6667 7.70317 33.6667 17C33.6667 26.2968 26.1302 33.8333 16.8334 33.8333Z"
                                    fill="#26466d" fillOpacity="0.61" />
                                <path d="M14.7124 22.9422L20.6377 17L14.7124 11.0579" stroke="white"
                                    strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                        </div>
                    </Swiper>
                </section>
            </section>
            <Modal />
            <ToastContainer />
            <Footer />
        </>
    )
}

export default Home;